import { FAIRE_DIRECT_EVERGREEN_MARKETPLACE_DISCOUNT_240506 } from "@faire/web-api/indigofair/settings/FAIRE_DIRECT_EVERGREEN_MARKETPLACE_DISCOUNT_240506";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingFaireDirectEvergreenMarketplaceDiscount = (): boolean =>
  getSettingValueWithoutAssignment(
    FAIRE_DIRECT_EVERGREEN_MARKETPLACE_DISCOUNT_240506,
    false
  );
